import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const getUserData = async () => {
    const { data } = await apiInstance.get(ENDPOINTS.AUTH_ME);
    return data
}